import React, { useState } from 'react';
import Box from '../../common/Box';
import Button from '../../common/Button';
import Input from '../Input';
import PhoneInput from '../PhoneInput';
import styles from './UserAccount.module.scss';
import { requiredValidator, isFormValid } from '../../../utils/validators';

const validators = [
  {
    key: 'first_name',
    validator: [requiredValidator],
  },
  {
    key: 'last_name',
    validator: [requiredValidator],
  },
  {
    key: 'phone',
    validator: [requiredValidator],
  },
];

function UserAccount(props) {
  let [changed, setChanged] = useState(false);
  let [user, setUser] = useState({
    first_name: props.user.first_name,
    last_name: props.user.last_name,
    phone: props.user.phone,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });

    if (!changed) {
      setChanged(true);
    }
  };

  const handleSubmit = (e) => {
    props.updateUser(user);
    setChanged(false);

    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  return (
    <Box toolbar="Profile" className={styles.accountWrapper}>
      <dl>
        <dt>First Name:</dt>
        <dd>
          <Input
            name="first_name"
            value={user.first_name}
            onChange={handleChange}
            fullWidth
            validate={[requiredValidator]}
          />
        </dd>

        <dt>Last Name:</dt>
        <dd>
          <Input
            name="last_name"
            value={user.last_name}
            onChange={handleChange}
            fullWidth
            validate={[requiredValidator]}
          />
        </dd>

        <dt>Email:</dt>
        <dd>{props.user.email}</dd>

        <dt>Phone:</dt>
        <dd>
          <PhoneInput
            name="phone"
            onChange={handleChange}
            placeholder="Phone Number"
            value={user.phone}
            noMargin
            blur
            validate={[requiredValidator]}
          />
        </dd>
      </dl>

      <div className={styles.actions}>
        <Button
          text="Update"
          type="submit"
          disabled={!changed || !isFormValid(user, validators)}
          onClick={handleSubmit}
        />
      </div>
    </Box>
  );
}

export default UserAccount;
